<template>
    <div class="sidebar-container mb-5" :class="{ 'sidebar-container--active': showSidebar }" @click="clickOutSidebar">
        <div class="sidebar box d-md-block">
            <div class="sidebar__header d-flex d-md-none">
                <div class="title w-100">
                    {{ $t(sidebarFilterTitle) }}
                    <span class="count">({{ $numberFormat(count) }})</span>
                </div>
                <img
                    v-lazy-load
                    class="ico"
                    src="/nuxt-assets/images/lazy-load-error.svg"
                    :data-src="`/nuxt-assets/images/icons/close.svg`"
                    :alt="$t('close')"
                    @click="closeSidebar()"
                />
            </div>

            <div class="sort d-block d-md-none">
                <h3 class="sidebar-filter__title h6">{{ $t(sidebarSortTitle) }}</h3>
                <div class="sort-tabs">
                    <nuxt-link
                        v-for="option in sorts"
                        :key="option.id"
                        class="sort-tabs__link"
                        :class="{ checked: sortSelected.id == option.id }"
                        :to="`${option.url}`"
                    >
                        {{ option.name }}
                    </nuxt-link>
                </div>
                <!--
                <fieldset class="form-group">
                    <div
                        v-for="option in sorts"
                        :key="option.id"
                        class="radio custom-control custom-radio"
                        :class="{ checked: sortSelected.id == option.id }"
                    >
                        <input
                            :id="`sort-input-${option.id}`"
                            :key="option.id"
                            v-model="sortSelected"
                            type="radio"
                            class="custom-control-input"
                            name="mobile-sort"
                            :value="option"
                            :class="{ checked: sortSelected.id == option.id }"
                        />
                        <label class="custom-control-label" :for="`sort-input-${option.id}`">{{ option.name }}</label>
                    </div>
                </fieldset>

                <span class="respo-bar d-sm-none">
                    <nuxt-link
                        class="btn btn-primary w-100"
                        :to="`${sortSelected.url || sorts[0].url}#product-list`"
                        @click="closeSidebar()"
                    >
                        {{ $t(sidebarSortSubmitLabel) }}
                    </nuxt-link>
                </span>
                -->
            </div>

            <Location v-if="isLocationFilterActive" class="template-xs" />

            <div v-if="sidebarCategories.length > 0" class="sidebar-filter expand is-open">
                <h3 class="sidebar-filter__title h6" @click="toggle">
                    {{ $t('category.title') }}
                </h3>
                <div class="vertical-scrollbar sidebar-filter__body">
                    <div class="filter-link">
                        <a v-for="(sidebarCategory, i) in sidebarCategories" :key="i" :href="sidebarCategory.shopUrlPath">
                            {{ sidebarCategory.title }} ({{ sidebarCategory.count }})
                        </a>
                    </div>
                </div>
            </div>

            <template v-for="(filter, id) in sidebarFilters" :key="id">
                <div
                    v-if="filter.type !== 'slider2'"
                    :class="filter.title === '' || filter.identifier === 'price' ? 'is-open ' + filter.identifier : ''"
                    class="sidebar-filter expand is-open"
                >
                    <h3 v-if="filter.title !== '' && filter.type === 'enum'" class="sidebar-filter__title h6" @click="toggle">
                        {{ filter.title }}
                        <span v-if="activeFilter(filter) > 0" class="count" v-html="activeFilter(filter)" />
                    </h3>
                    <!-- FIXME ES2-2697 - minRating -->
                    <h3
                        v-if="filter.title !== '' && filter.type === 'minRating' && hasValidRatingItems"
                        class="sidebar-filter__title h6"
                        @click="toggle"
                    >
                        {{ filter.title }}
                    </h3>

                    <ObjectsFilterToolsRangeSlider
                        v-if="['number', 'range'].includes(filter.type) && filter.selection?.from !== null"
                        :filter="filter"
                        @click="toggle"
                    />

                    <div v-else class="sidebar-filter">
                        <div
                            v-if="filter.title !== '' && filter.type === 'enum' && filter.searchable !== false"
                            class="sidebar-filter__search"
                        >
                            <div class="input-group sidebar-filter__search-group me-sm-2 mb-sm-0">
                                <i v-if="inputSearch[id]" class="ico-close-filter" @click="inputSearch[id] = ''"></i>
                                <input
                                    :id="'form-input-search' + id"
                                    v-model="inputSearch[id]"
                                    class="sidebar-filter__search-input form-control"
                                    :placeholder="$t('sideBar.search')"
                                    type="text"
                                />
                            </div>
                        </div>

                        <div
                            class="sidebar-filter__body"
                            :class="{
                                'vertical-scrollbar': true,
                                notranslate: [$t('search.searchBrands'), $t('search.searchProductLines')].includes(filter.title),
                            }"
                            @scroll="onScroll"
                        >
                            <div v-if="filter.type === 'enum'" class="filter-checkbox">
                                <component
                                    :is="canBeAnchorTag(option.url) ? 'a' : 'span'"
                                    v-for="(option, index) in filteredList(filter, id)"
                                    :id="option.id ? `option-${option.id}` : null"
                                    :key="index"
                                    :href="canBeAnchorTag(option.url) ? `${option.url}#product-list` : null"
                                    class="checkbox"
                                    :class="{
                                        'is-active': option.isActive,
                                        disabled: option.count === 0,
                                        'd-none': isMobile() && index > 30,
                                    }"
                                    :style="`color: ${option.textColor}`"
                                    :data-cy="`${option.title}`"
                                    @click.prevent="redirectToUrl(option.url, option.id, true)"
                                >
                                    <img
                                        v-if="option.image"
                                        :src="`https://www.pilulka.cz${option.image}`"
                                        height="15"
                                        class="pr-1 d-inline-block"
                                        style="max-height: 20px; padding-right: 5px"
                                    />
                                    <span>{{ option.title }}</span
                                    >&nbsp;({{ $numberFormat(option.count) }})
                                </component>

                                <div v-if="!filteredList(filter, id).length">
                                    <div class="alert alert-danger px-5" role="alert">{{ $t('sideBar.notFoundItems') }}</div>
                                </div>
                            </div>

                            <!-- FIXME ES2-2697 - minRating -->
                            <div
                                v-if="filter.type === 'minRating' && hasValidRatingItems"
                                class="filter-checkbox"
                                data-cy="filter-checkbox"
                            >
                                <component
                                    :is="canBeAnchorTag(item.url) ? 'a' : 'span'"
                                    v-for="(item, index) in (filter.items ?? []).filter((item) => item.count > 0)"
                                    :key="index"
                                    :href="canBeAnchorTag(item.url) ? `${item.url}#product-list` : null"
                                    class="checkbox"
                                    :class="{ 'is-active': item.isActive }"
                                    :aria-label="item.title"
                                    @click.prevent="redirectToUrl(item.url, null, true)"
                                >
                                    <ObjectsRating :rating="item.rating" :total="item.count" :total-text="item.title" size="size-xl" />
                                </component>
                            </div>

                            <!--                            <nuxt-link v-if="filter.type === 'boolean'" :to="filter.url" class="checkbox">-->
                            <!--                                {{ filter.title }}-->
                            <!--                            </nuxt-link>-->
                        </div>

                        <a
                            v-if="filter.options && filter.options.length > 5 && filter.type === 'enum' && filter.title !== ''"
                            class="d-sm-none show-all"
                            href="#"
                            @click.prevent="showFullList"
                            >{{ $t('sideBar.showList') }} {{ filter.title }}</a
                        >
                    </div>
                </div>
            </template>
            <span v-if="selectedFilters.length > 0" class="text-center mt-1 mb-3 d-none d-md-block">
                <nuxt-link :to="`${basePath}#product-list`" class="text-brand px-2 fs-13" @click="closeSidebar()">
                    {{ $t('sideBar.clearAll') }}
                </nuxt-link>
            </span>
            <span class="respo-bar d-sm-none">
                <span v-if="selectedFilters.length > 0" class="mb-3 d-block text-center">
                    <nuxt-link :to="`${basePath}#product-list`" class="text-brand px-2 fs-13" @click="closeSidebar()">
                        {{ $t('sideBar.clearAll') }}
                    </nuxt-link>
                </span>

                <a class="btn btn-primary w-100" href="#product-list" @click="closeSidebar()">{{ $t(sidebarFilterSubmitLabel) }}</a>
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Location from '~/components/objects/Location.vue'
import { useLayoutStore } from '~/stores/layout'
import Filter from '~/models/Filters/Filter'
import FilterOption from '~/models/Filters/FilterOption'

export default {
    components: { Location },

    props: {
        sidebarFilterTitle: {
            type: String,
            default: 'sideBar.filterProduct',
        },
        sidebarFilterSubmitLabel: {
            type: String,
            default: 'sideBar.send',
        },
        sidebarSortTitle: {
            type: String,
            default: 'sideBar.sortProduct',
        },
        sidebarSortSubmitLabel: {
            type: String,
            default: 'sideBar.viewProduct',
        },
        sidebarFilters: {
            type: Array as PropType<Filter[]>,
            required: true,
            toggle: [],
        },
        sidebarCategories: {
            type: Array as PropType<{ title: string; count: number; shopUrlPath: string }[]>,
            required: false,
            default: Infinity,
        },
        basePath: {
            type: String,
            required: true,
        },
        isLocationFilterActive: {
            type: Boolean,
            default: false,
        },
        sorts: {
            type: Array as PropType<{ id: number; name: string; url: string }[]>,
            default: Infinity,
        },
        selectedFilters: {
            type: Array,
            default: Infinity,
        },
        count: {
            type: Number,
            required: true,
        },
        defaultSort: {
            type: Number,
            required: false,
            default: 1,
        },
    },

    data() {
        const params = useRoute().matched[0].props.default as { [name: string]: string }
        return {
            data: {},
            inputSearch: {} as { [name: number]: string },
            sortSelected: {
                id: useRoute().query.sort || params.s || this.defaultSort,
                url: params.fullPath,
            },
        }
    },

    computed: {
        showSidebar(): boolean {
            const layoutStore = useLayoutStore()
            return layoutStore.showSidebar
        },
        sidebarMode(): string {
            const layoutStore = useLayoutStore()
            return layoutStore.sidebarMode
        },
        hasValidRatingItems(): boolean {
            const filters = this.sidebarFilters
            let hasValidRatingItems = false

            filters.forEach((filter: Filter) => {
                if (filter.type !== 'minRating') {
                    return
                }
                const items = filter.items ?? []
                items.forEach((item) => {
                    if (item.count > 0) {
                        hasValidRatingItems = true
                    }
                })
            })

            return hasValidRatingItems
        },
    },

    watch: {
        showSidebar(): void {
            document.body.className = this.showSidebar ? 'noscroll filter--open' : ''
        },
    },

    mounted() {
        const route = useRoute()
        if (this.showSidebar && route.hash.includes('option')) {
            const scrollElementId = route.hash.replace(/^#/, '')
            const scrollElement = document.getElementById(scrollElementId)
            if (scrollElement) {
                if (scrollElement.classList.contains('d-none')) {
                    scrollElement.parentElement?.firstElementChild?.scrollIntoView({ block: 'center' })
                } else {
                    scrollElement.scrollIntoView({ block: 'center' })
                }
            }
        }
    },

    methods: {
        onScroll(event: any) {
            if (!this.isMobile()) {
                return
            }

            const scrollHeight = event.target.scrollHeight
            const scrollTop = event.target.scrollTop
            const clientHeight = event.target.clientHeight

            if (scrollTop + clientHeight >= scrollHeight) {
                ;[...event.target.querySelectorAll('a.d-none')].slice(0, 30).forEach(function (item) {
                    item.classList.remove('d-none')
                })
            }
        },

        async redirectToUrl(url: string, optionId: number | null = null, focusOnList: boolean) {
            if (this.isMobile() && optionId) {
                url = `${url}#option-${optionId}`
            } else if (!this.isMobile() && focusOnList) {
                url = `${url}#product-list`
            }

            await safeNavigateTo(url)
        },

        showFullList(event: any): void {
            event.target.parentElement.classList.toggle('showlist')
            event.target.style.display = 'none'
        },

        closeSidebar(): void {
            setTimeout(() => {
                const layoutStore = useLayoutStore()
                layoutStore.closeSidebar()
            }, 0)
        },

        filteredList(filter: Filter, id: number): FilterOption[] {
            const options =
                filter.options?.map((option: FilterOption) => {
                    option.url = option.url.replace(/(&|)page=\d+/, '')

                    return option
                }) || []
            if (this.isMobile() && options.length > 30) {
                options.sort((a, b) => Number(b.isActive) - Number(a.isActive))
            }

            if (this.inputSearch[id]) {
                return options.filter((post: any): boolean => {
                    return post.title.toLowerCase().includes(this.inputSearch[id].toLowerCase())
                })
            } else {
                return options
            }
        },

        clickOutSidebar(e: any): void {
            if (e.target.classList[0] === 'sidebar-container') {
                this.closeSidebar()
            }
        },

        toggle(event: any): void {
            const childrens = event.target.parentElement.children
            for (const item of childrens) {
                if (item.classList.contains('sidebar-filter__body')) {
                    if (item.clientHeight > 0) {
                        item.style.height = item.clientHeight + 'px'
                    }
                }
            }
            event.target.parentElement.classList.toggle('is-open')
        },

        activeFilter(filter: Filter): number {
            return (
                filter.options?.reduce((count, item) => {
                    return item.isActive ? count + 1 : count
                }, 0) || 0
            )
        },

        canBeAnchorTag(url: string): boolean {
            const regex = /(priceFrom=|priceTo=|vt\[0\]=|minRating=)/

            return !regex.test(url)
        },

        isMobile(): boolean {
            return useDevice().isMobile
        },
    },
}
</script>

<style lang="scss">
@import 'assets/scss/tools/mixins';

@import '../../node_modules/bootstrap/scss/functions';
@import '../../node_modules/bootstrap/scss/variables';
@import '../../node_modules/bootstrap/scss/mixins';

.checkbox {
    cursor: pointer;

    &:hover {
        color: $color-cta;
    }
}

.sidebar {
    box-shadow: $box-shadow;
    border-radius: 10px;
    padding: 0 1rem;
    background-color: $color-white;
    max-width: 350px;
    width: 100%;
    height: 100%;
    padding-bottom: 5px;

    .sort .radio {
        margin: 0 -1em;
        padding: 0.75em 1em;
        border-bottom: 2px solid $color-grey;
    }

    &__header {
        border-bottom: 2px solid $color-grey;
    }

    @include media-breakpoint-up(md) {
        padding-top: 0;
    }

    @include media-breakpoint-down(md) {
        max-width: 100%;
        background-color: $color-white;
        z-index: 100;
        padding-bottom: 60px;
        overflow-y: auto;

        &.box {
            border-radius: 0;
            padding-bottom: 110px;
            padding-top: 20px;
            overflow-x: hidden;
        }
    }

    .respo-bar {
        position: fixed;
        background-color: $color-white;
        bottom: -100%;
        left: 0;
        z-index: 100;
        box-shadow: 0 -4px 10px -5px hsla(0, 0%, 0%, 0.102);
        width: 100%;
        padding: 1em;
    }

    &__header {
        display: flex;
        align-items: center;
        padding: 0.75em 1em;
        font-size: 1.25rem;
        margin: -0.75em -1em 0.5em;
        font-weight: 500;

        .ico {
            width: 15px;
            cursor: pointer;
            margin-right: 0;
        }

        .count {
            color: $color-dark;
            font-size: 0.75em;
        }
    }

    .place-input {
        border: none;
        width: 100%;
    }

    .place {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #ced4da;
        padding: 10px !important;

        &__content {
            display: flex;

            .ico--point {
                filter: grayscale(1);
                opacity: 0.38;
            }

            input {
                border: none;
                width: 100%;
                font-weight: 500;

                &:focus {
                    outline: 0;
                }
            }
        }
    }

    .simple-range-slider,
    .simple-range-slider-bg-bar .filter-slider {
        max-width: 265px;
    }

    .sidebar-filter {
        &__search {
            margin: 0 -15px;
            padding: 0 15px 10px;
            box-shadow: 0px 4px 10px -5px rgb(0 0 0 / 10%);
        }

        &__search-group {
            .ico-close-filter {
                height: 15px;
                width: 15px;
                background: url(/nuxt-assets/images/icons/close-filter.svg) no-repeat 50%;
                background-size: contain;
                position: absolute;
                right: 5px;
                z-index: 5;
                top: 10px;
                cursor: pointer;
            }
        }

        &__search-input {
            height: 34px;
            padding: 5px 10px 5px 30px;
            border-radius: 50px;
            position: relative;
            background: $color-grey url(/nuxt-assets/images/icons/magnifier.svg) no-repeat 7px;
            background-size: 16px 16px;
            border: 0;

            @media (min-width: 890px) {
                font-size: 14px;
            }

            &:not(:first-child) {
                border-top-left-radius: 3px;
                border-bottom-left-radius: 3px;
            }
        }

        &:not(:last-of-type) {
            border-bottom: 2px solid $color-grey;
        }

        &.price {
            border-bottom: 0;
        }

        &__body {
            max-height: 300px;
            border-radius: 3px;

            @media (max-width: 480px) {
                max-height: 180px;
            }

            .filter-checkbox {
                margin: 1em 0;
            }

            .filter-link {
                margin: 0 0 1em 0;

                a {
                    display: block;
                    margin: 0.6em 0;
                    font-size: 14px;
                    text-decoration: underline;
                    color: $color-dark;

                    &:hover {
                        color: $color-cta;
                    }
                }
            }

            &.show-all {
                max-height: none;
            }

            .count {
                color: $color-dark;
                font-size: 1em;
            }
        }

        &__title {
            font-size: 1rem;
            padding: 1rem 0;
            cursor: pointer;
            margin-bottom: 0;
            display: flex;
            justify-content: space-between;
            font-weight: 500;

            .count {
                display: inline-block;
                background-color: #ffeef1;
                color: $color-cta;
                line-height: 16px;
                text-align: center;
                border-radius: 50px;
                font-size: 10px;
                margin: 0 auto 0 1em;
                padding: 0 5px;
            }

            a {
                font-size: 14px;
                text-decoration: underline;
            }
        }

        &.expand {
            .sidebar-filter__body,
            .sidebar-filter__search {
                height: 0;
                transition: all 0.3s ease-in;
            }

            .sidebar-filter__title::after {
                margin-right: 2px;
                transition: all 0.3s ease-in;

                @include ico-arrow;
            }
        }

        &.expand:not(.is-open) {
            .sidebar-filter__body,
            .sidebar-filter__search {
                margin: 0;
                padding: 0;
                height: 0 !important;
                overflow: hidden;
                font-size: 0;
                transition: all 0.3s ease-in;
            }
        }

        &.is-open {
            .sidebar-filter__body,
            .sidebar-filter__search {
                max-height: 300px;
                transition: all 0.3s ease-in;
                display: block;
            }

            .sidebar-filter__search {
                height: 44px;
            }

            .sidebar-filter__body {
                height: auto;
            }

            .sidebar-filter__title::after {
                transform: rotate(315deg);
                transition: all 0.3s ease-in;
            }
        }

        &.showlist .sidebar-filter__body {
            overflow-y: auto;
            max-height: 300px;
        }
    }
}

@include media-breakpoint-down(md) {
    .fixed-page {
        overflow: hidden;
    }

    .filter--open .site-header,
    .filter--open .menuFooterMobile {
        display: none !important;
    }

    .sidebar-container {
        position: fixed;
        z-index: 301;
        top: 0;
        width: 100%;
        background: hsla(0, 0%, 88.2%, 0.5);
        overflow-y: auto;
        height: 100%;
        left: -100%;
        opacity: 0;
        transition: 200ms ease-in-out;

        &--active {
            transition: 200ms ease-in-out;
            opacity: 1;
            left: 0;

            .respo-bar {
                bottom: 0;
            }
        }
    }
}

.filters-active {
    display: flex;
    align-items: center;
    font-size: 13px;
    margin-bottom: 1em;

    &__list {
        overflow-x: auto;
        display: flex;
        align-items: center;
        margin-bottom: 0.5em;
    }

    .remove {
        line-height: 20px;
        padding: 6px;
        margin-top: -6px;
        white-space: nowrap;
        color: $color-green-darker;

        @include screen-md {
            color: $color-cta;
        }
    }

    .item {
        height: 30px;
        background-color: $color-green-light;
        padding: 0 30px 0 15px;
        line-height: 28px;
        white-space: nowrap;
        display: inline-block;
        color: $color-green-darker;
        max-width: 100%;
        position: relative;
        border-radius: 50px;
        border: 1px solid transparent;
        overflow: hidden;
        text-overflow: ellipsis;

        @include screen-md {
            background-color: #ffeef1;
            color: $color-cta;
        }

        &:hover {
            @media (min-width: 1024px) {
                border: 1px solid $color-cta;
            }
        }

        &::before,
        &::after {
            position: absolute;
            width: 14px;
            height: 1px;
            background-color: $color-green-darker;
            top: 14px;
            right: 10px;
            content: '';
            display: inline-block;
            margin-left: 0.5rem;

            @include screen-md {
                background-color: $color-cta;
            }
        }

        &::before {
            transform: rotate(45deg);
        }

        &::after {
            transform: rotate(-45deg);
        }
    }
}

/* .overlay {
  background-color: $color-dark;
  opacity: 0.75;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
} */

.no-scroll {
    position: fixed;
    width: 100%;
}

.top-0 {
    top: 0;
}

.left-0 {
    left: 0;
}

.show-all {
    display: none;
    margin: 0.5em 0 1em;
    font-size: 14px;
    font-weight: 500;
}

.sticky {
    position: sticky;
    position: -webkit-sticky;
    z-index: 201;
    top: 140px;
    transition: top 1s;
}

.header-sticky {
    .sticky {
        top: 20px;
    }
}

.filter-slider .input-group input[type='text'] {
    width: 40px;
    text-align: center;
}

.sidebar-filter__search
    .input-group
    > :not(:first-child):not(.dropdown-menu):not(.form-floating):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(
        .invalid-feedback
    ) {
    border-radius: 50px;
    margin-left: 0;
}

.filter-checkbox a.disabled {
    color: #999;
    cursor: not-allowed;

    &:hover {
        color: #999;
    }
}

.sort-tabs {
    overflow-x: scroll;
    white-space: nowrap;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    &__link {
        display: inline-block;
        padding: 0 0.875rem;
        font-size: 14px;
        line-height: 2.5rem;
        background-color: $color-grey;
        cursor: pointer;
        color: $color-dark;
        font-weight: 600;

        &:hover {
            background-color: $color-cta-extra-light;
        }

        &.checked {
            background-color: $color-cta-extra-light;
        }

        &:first-child {
            border-top-left-radius: $border-radius;
            border-bottom-left-radius: $border-radius;
        }

        &:last-child {
            border-top-right-radius: $border-radius;
            border-bottom-right-radius: $border-radius;
        }
    }
}
</style>
